var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpCircleOutlineLabels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.275,
    height: 14.275,
    viewBox: "0 0 14.275 14.275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-help-circle-outline",
    "data-name": "Icon ionic-ios-help-circle-outline",
    transform: "translate(0.2 0.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-help-circle-outline-2",
    "data-name": "Icon ionic-ios-help-circle-outline",
    transform: "translate(-3.375 -3.375)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M10.312,4.309A6,6,0,1,1,6.067,6.067a5.964,5.964,0,0,1,4.246-1.758m0-.934a6.937,6.937,0,1,0,6.937,6.937,6.936,6.936,0,0,0-6.937-6.937Z",
    transform: "translate(0 0)",
    stroke: "#fafafa",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M15.658,11.25c1.251,0,2.111.694,2.111,1.691a1.631,1.631,0,0,1-.937,1.481c-.58.337-.777.584-.777,1.011V15.7H14.9l-.01-.287a1.388,1.388,0,0,1,.787-1.468c.564-.337.8-.55.8-.964a.81.81,0,0,0-.9-.717.844.844,0,0,0-.894.82H13.5A1.9,1.9,0,0,1,15.658,11.25Zm-.877,5.717a.716.716,0,1,1,.714.687A.7.7,0,0,1,14.781,16.967Z",
    transform: "translate(-5.322 -4.139)",
    stroke: "#fafafa",
    strokeWidth: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircleOutlineLabels);
export default __webpack_public_path__ + "static/media/help-circle-outline-labels.78678da6934c6fb8df7c3a3fa2a55ce0.svg";
export { ForwardRef as ReactComponent };